var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3504 12.1133H12.7453C11.9473 12.1133 11.25 12.6875 11.25 13.4762V28.1137C11.25 28.9066 11.9473 29.6133 12.7453 29.6133H27.3461C28.1484 29.6133 28.75 28.902 28.75 28.1137V13.4762C28.7547 12.6875 28.1484 12.1133 27.3504 12.1133ZM16.6746 26.7004H14.1676V18.9055H16.6746V26.7004ZM15.5078 17.7203H15.4898C14.6875 17.7203 14.168 17.123 14.168 16.3754C14.168 15.6141 14.7012 15.0309 15.5215 15.0309C16.3418 15.0309 16.8438 15.6098 16.8617 16.3754C16.8613 17.123 16.3418 17.7203 15.5078 17.7203ZM25.8371 26.7004H23.3301V22.4383C23.3301 21.4172 22.9652 20.7195 22.0582 20.7195C21.3652 20.7195 20.9551 21.1883 20.7727 21.6449C20.7043 21.809 20.6859 22.0324 20.6859 22.2605V26.7004H18.1789V18.9055H20.6859V19.9902C21.0508 19.4707 21.6207 18.723 22.9469 18.723C24.5926 18.723 25.8375 19.8078 25.8375 22.1465L25.8371 26.7004Z",
    fill: "#929CB0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.36328,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E7EBF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bf2898d23ce82d5faeac4dd28bfbc603.svg";
export { ForwardRef as ReactComponent };